// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DayStep__container___12quL{display:flex;align-items:center}.DayStep__day___1JQjO{color:inherit;font-weight:400;font-size:14px;line-height:20px;min-width:42px;color:#acbef7}.DayStep__day___1JQjO,.DayStep__iconBg___wWkKQ{margin-right:16px}.DayStep__iconBg___wWkKQ{display:flex;align-items:center;justify-content:center;width:48px;min-width:48px;height:48px;min-height:48px;border-radius:50%;background-color:#ebf5ff}.DayStep__icon___2HY_C{width:20px;height:24px}.DayStep__isSkip___cgvXv{margin-left:55px;background-color:transparent!important}.DayStep__description___1FvQ-{color:#6b6651}.DayStep__description___1FvQ- strong{color:#2c2302}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "DayStep__container___12quL",
	"day": "DayStep__day___1JQjO",
	"iconBg": "DayStep__iconBg___wWkKQ",
	"icon": "DayStep__icon___2HY_C",
	"isSkip": "DayStep__isSkip___cgvXv",
	"description": "DayStep__description___1FvQ-"
};
module.exports = ___CSS_LOADER_EXPORT___;
